// 给每个小题的选项设置answer字段，true表示正确答案，false表示错误答案，null表示未设置答案
import { smallQuestionTypeEnum } from '@/views/PaperCollect/enum'
import lodash from 'lodash'

export function setAnswerForSmallList(smallList) {
  return smallList.map(small => {
    small.optionsTypeList = small.optionsTypeList.map(option => {
      if (small.answer === null) {
        option.answer = null
      } else {
        option.answer = small.answer.includes(option.id)
      }
      return option
    })
    return small
  })
}

// 根据正确率获取色值
export function getColorByScore(score) {
  if (score >= 0 && score < 60) {
    return {
      color: '#FF3C30',
      bgColor: 'rgba(255,60,48,0.1)',
      capsuleBgColor: 'linear-gradient( 90deg, #FF3C30 0%, #FF7B72 100%)'
    }
  } else if (score >= 60 && score < 85) {
    return {
      color: '#FFA516',
      bgColor: 'rgba(255,165,22,0.1)',
      capsuleBgColor: 'linear-gradient( 270deg, #FFD131 0%, #FFA516 100%)'
    }
  } else if (score >= 85 && score <= 100) {
    return {
      color: '#1DC060',
      bgColor: 'rgba(29,192,96,0.1)',
      capsuleBgColor: 'linear-gradient( 270deg, #41EA86 0%, #1DC060 100%)'
    }
  }
  return {}
}
